import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastComponent } from './toast.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
  declarations: [ToastComponent],
  exports: [ToastComponent],
  imports: [
    MatIconModule,
    CommonModule,
    TranslocoModule
  ]
})
export class ToastModule { }
